import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
    Button,
    Textarea,
    Label,
} from '@quadminds/mindkit';
import { IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';

interface SendFeedbackDialogProps {
    isDialogOpen: boolean;
    handleClose: () => void;
    feedback: string;
    setFeedback: (value: string) => void;
    isSubmitting: boolean;
    handleSubmit: () => void;
    userInfo: IAuthMeV2OutputDto | undefined;
    isImpersonated: boolean;
}

const SendFeedbackDialog = ({
    isDialogOpen,
    handleClose,
    feedback,
    setFeedback,
    isSubmitting,
    handleSubmit,
}: SendFeedbackDialogProps) => {
    return (
        <Dialog open={isDialogOpen} onOpenChange={handleClose}>
            <DialogContent className="sm:max-w-[600px] bg-card">
                <DialogHeader>
                    <DialogTitle className="text-2xl font-semibold uppercase tracking-wide">
                        ENVIAR FEEDBACK
                    </DialogTitle>
                    <DialogDescription className="text-muted-foreground text-base mt-2 border-b pb-4">
                        Envíe seu feedback para mejorar la Plataforma
                    </DialogDescription>
                </DialogHeader>

                <div className="py-2">
                    <div className="space-y-2">
                        <Label htmlFor="feedback" className="text-sm font-medium uppercase tracking-wide">
                            FEEDBACK
                        </Label>
                        <Textarea
                            id="feedback"
                            value={feedback}
                            onChange={(e) => setFeedback(e.target.value)}
                            placeholder="Mejorar la información sobre los conductores"
                            className="min-h-[120px] resize-none bg-background"
                            autoFocus
                        />
                    </div>
                </div>

                <DialogFooter className="gap-2 sm:gap-0 border-t pt-5">
                    <Button
                        type="button"
                        variant="ghost"
                        onClick={handleClose}
                        disabled={isSubmitting}
                        className="text-muted-foreground hover:text-foreground"
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="button"
                        onClick={handleSubmit}
                        disabled={feedback.trim().length === 0 || isSubmitting}
                        className="bg-primary hover:bg-primary/90 text-primary-foreground"
                    >
                        {isSubmitting ? 'Enviando...' : 'Enviar Feedback'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default SendFeedbackDialog;
